import React from "react";

const ModalBody = function(props) {

  let style = {};

  if (props.style) {
    style = {
      ...props.style,
    };
  }

  return (
    <div
      className="text-left modal-body clearfix"
    >
      { props.children }
    </div>
  );

};

export default ModalBody;
